import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filter',
  pure: false
})
export class SearchPipe implements PipeTransform {
  transform(items: any[], searchText: string): any {
    if (!items || !searchText) {
      return items;
    }
    return items.filter(function (item) {
      return Object.values(item).map(function (value) {
        return String(value);
      }).find(function (value) {
        return value.toLowerCase().includes(searchText.toLowerCase());
      });
    });
    //return items.filter(item => JSON.stringify(item).toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
  }
}
@Pipe({ name: 'searchbytitle', pure: false })
export class SearchByNamePipe implements PipeTransform {
  transform(request: any[], searchText: any, colname: string): any {
   
    if (!request || !searchText)
      return request;

    else {
      //if (colname == 'formname-documentid') {
      //  var col = colname.split('-');
      //  return request.filter((item) => {
      //    return item[col[0]].toLowerCase().includes(searchText) || item[col[1]].toLowerCase().includes(searchText)
      //    //return request.filter(function (req) {

      //    //  return req.requesttype.toLowerCase().includes(searchText);
      //  })
      //}
      //else {
      return request.filter((item) => {
        return item[colname].toLowerCase().includes(searchText.toLowerCase());
        //return request.filter(function (req) {

        //  return req.requesttype.toLowerCase().includes(searchText);
      })
      //}

    }

  }
}
